import { useEffect, useState } from 'react'
import '../AccountingEntry.scss'

import { Column } from 'primereact/column'
import { ColumnGroup } from 'primereact/columngroup'
import { Row } from 'primereact/row'
import { useIntl } from 'react-intl'
import DataTableWorkerProjects from '../../../components/accounting-entry/DataTableWorkerProjects'
import WorkerSelector from '../../../components/accounting-entry/WorkerSelector'
import Button from '../../../components/common/buttons'
import LabeledCheckbox from '../../../components/common/form-components/labeled-checkbox/LabeledCheckbox'
import LabeledDropdown from '../../../components/common/form-components/labeled-dropdown/LabeledDropdown'
import LabeledNumber from '../../../components/common/form-components/labeled-inputs/LabeledNumber'
import AccountingEntryService from '../../../services/accounting-entry/accountingEntry.service'
import swalAlert from '../../../utils/helpers/swalAlert'
import '../AccountingEntry.scss'

const AccountingEntryAnalyticalDistributionForm = ({
  companyCode,
  currentRowData,
  hide,
}) => {
  const { formatMessage: msg } = useIntl()
  const [projects, setProjects] = useState([])
  const [tempProjects, setTempProjects] = useState([])
  const [workerCode, setWorkerCode] = useState(null)
  const [projectCode, setProjectCode] = useState(null)
  const [distribution, setDistribution] = useState(0)
  const [isSubstitution, setIsSubstitution] = useState(false)
  // const [filterWorker, setFilterWorker, prevFilterWorker] = useStatePrev(workerCode)

  const FULL_DISTRIBUTION = 100

  useEffect(() => {
    preprocessRowData(currentRowData)
    retrieveProjects()
  }, [])
  useEffect(() => {
    retrieveProjects()
  }, [tempProjects])

  const preprocessRowData = (rowData) => {
    if (rowData) {
      if (rowData.projects)
        setTempProjects(
          // API Inconsistency in attrib names
          rowData.projects.map((prj) => {
            prj.projectCode = prj.code
            prj.distribution = prj.percentage
            return prj
          }),
        )
      if (rowData.workerCode) setWorkerCode(rowData.workerCode)
      if (rowData.projects) setTempProjects([...rowData.projects])
      if (rowData.isSubstitution) setIsSubstitution(rowData.isSubstitution)
    }
  }

  const handleSubmit = async () => {
    const body = {
      companyCode: String(companyCode),
      projectList: tempProjects.map((tempProject) => ({
        code: tempProject.projectCode,
        percentage: tempProject.distribution,
      })),
      isSubstitution,
      workerCodeList: [workerCode],
    }
    await AccountingEntryService.workers.setProjects(body)
    hide()
  }

  const handleDeleteWorker = async () => {
    const confirm = await swalAlert.warning(
      msg({ id: 'swal.title.delete' }),
      msg({ id: 'button.cancel' }),
      msg({ id: 'button.delete' }),
    )
    if (confirm?.isConfirmed) {
      const response = await AccountingEntryService.workers.removeWorker(
        currentRowData?._id,
      )
      if (response) {
        hide()
      }
    }
  }

  const retrieveProjects = async () => {
    const response = await AccountingEntryService.projects.getProjects({
      companyCode,
    })
    response.resp = response.resp.filter((project) =>
      tempProjects.length > 0
        ? !tempProjects.find(
            (tempProject) => tempProject.projectCode === project.projectCode,
          )
        : true,
    )
    if (response && response?.resp) setProjects(response?.resp)
  }

  const handleAddProject = () => {
    setTempProjects((prev) => [
      ...prev,
      {
        workerCode,
        projectCode,
        distribution,
        code: projectCode,
        percentage: distribution,
      },
    ])
    setProjectCode(null)
    setDistribution(0)
  }

  const handleDeleteProject = (rowData) => {
    setTempProjects(
      tempProjects.filter(
        (tempProject) => tempProject.projectCode !== rowData.projectCode,
      ),
    )
  }

  const totalDistribution = () => {
    return Number(
      tempProjects.reduce((acum, tempProject) => {
        return Number(Number(acum) + Number(tempProject.distribution))
      }, 0) || 0,
    )
  }

  const totalFutureDistribution = () => {
    return (
      Number(
        tempProjects.reduce((acum, tempProject) => {
          return Number(Number(acum) + Number(tempProject.distribution))
        }, 0),
      ) + distribution || 0
    )
  }

  const formFields = (
    <div>
      <WorkerSelector
        companyCode={companyCode}
        disabled={!!currentRowData}
        value={workerCode}
        onChange={(e) => setWorkerCode(e.target.value)}
      />
      {/* <LabeledDropdown 
                idLabel='worker'
                name='workerCode'
                required
                options={workers}
                optionLabel="workerName"
                optionValue="workerCode"
                showClear={workerCode}
                value={workerCode}
                filter
                onChange={(e) => setWorkerCode(e.target.value)}
            /> */}
      <LabeledDropdown
        idLabel="project"
        name="projectCode"
        required
        options={projects}
        optionLabel="projectName"
        optionValue="projectCode"
        showClear={projectCode}
        value={projectCode}
        filter
        onChange={(e) => setProjectCode(e.target.value)}
        onFilter={() => null}
      />
      <LabeledNumber
        name="distribution"
        min={0}
        max={FULL_DISTRIBUTION}
        idLabel="distribution"
        required
        value={distribution}
        classNameBox={
          totalFutureDistribution() === FULL_DISTRIBUTION
            ? 'text-success'
            : 'text-danger'
        }
        onChange={(e) => setDistribution(e.target.value)}
        style={{ width: '100%' }}
        mode="decimal"
        minFractionDigits={2}
        maxFractionDigits={2}
      />
      <span
        className={
          totalFutureDistribution() > FULL_DISTRIBUTION
            ? 'text-danger'
            : totalFutureDistribution() === FULL_DISTRIBUTION
              ? 'text-success'
              : undefined
        }
        style={{ float: 'right' }}
      >
        {totalDistribution()}%{' + '}
        {distribution || 0}%{' = '}
        {totalFutureDistribution()}%
      </span>
      <LabeledCheckbox
        name="isSubstitution"
        idLabel="substitutions"
        onChange={(e) => setIsSubstitution(e.target.value)}
        checked={isSubstitution}
      />
    </div>
  )

  const footerGroup = (
    <ColumnGroup>
      <Row>
        <Column footer={`${msg({ id: 'total' })}:`} />
        <Column
          className={
            totalDistribution() === FULL_DISTRIBUTION
              ? 'bg-success'
              : totalDistribution() < FULL_DISTRIBUTION &&
                  totalDistribution() > 0
                ? 'bg-danger'
                : ''
          }
          footer={() => totalDistribution() + '%'}
          align="right"
        />
        <Column
          colSpan={2}
          className={
            totalDistribution() === FULL_DISTRIBUTION
              ? 'bg-success'
              : totalDistribution() < FULL_DISTRIBUTION &&
                  totalDistribution() > 0
                ? 'bg-danger'
                : ''
          }
        />
      </Row>
    </ColumnGroup>
  )

  return (
    <div className="accounting-entry-form modal-content-wrapper">
      <form className="form-content">
        <div className="wrapper-flex">
          <div className="flex-grid" style={{ width: '50%' }}>
            {formFields}
          </div>
          <div className="flex-grid" style={{ width: '50%' }}>
            <DataTableWorkerProjects
              showWhenNoData
              data={tempProjects}
              footerGroup={footerGroup}
              handleDelete={handleDeleteProject}
            />
          </div>
        </div>
        <div
          className="wrapper-flex wrapper-form-btns"
          style={{ overflow: 'hidden' }}
        >
          <div style={{ width: '100%', textAlign: 'left' }}>
            <Button
              btnClass="btn btn__bg-dark-blue"
              iconClass="pi-trash"
              iconRight
              btnText={msg({ id: 'button.delete' })}
              float="left"
              onHandleClick={(e) => handleDeleteWorker(e)}
            />
          </div>
          <Button
            type="button"
            isDisabled={
              !workerCode ||
              !projectCode ||
              !distribution ||
              !distribution > 0 ||
              totalFutureDistribution() > FULL_DISTRIBUTION
            }
            btnClass="btn btn__bg-dark-blue"
            iconRight
            iconSize="1.2rem"
            iconClass="pi-plus"
            btnText="Añadir"
            onHandleClick={handleAddProject}
          />
          <Button
            btnClass="btn btn__bg-orange"
            iconClass="pi-save"
            iconRight
            btnText={msg({ id: 'button.save' })}
            isDisabled={totalDistribution() !== FULL_DISTRIBUTION}
            onHandleClick={(e) => handleSubmit(e)}
          />
        </div>
      </form>
    </div>
  )
}
export default AccountingEntryAnalyticalDistributionForm
